// extracted by mini-css-extract-plugin
export default {"formBlock":"cert_formBlock__6miuw","formInputBlock":"cert_formInputBlock__fIEjF","formInput":"cert_formInput__XPF0Q"};